export const newsroomExampleChat = [
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message: 'Need a contact for Sean Spicer ',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      '### Trump’s Former Press Secretary \n- **Name**: Sean Spicer \n- **Cell**: [703-623-6167](tel:7036236167) \n- **Email**: sean@seanspicer.com\n\n ',
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message: 'Need a financial expert on tariffs ',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      '### Ted Jenkin  \n- **Cell**: [770-349-9141](tel:7703499141) \n- **Email**: ted@exitwealth.com \n- **Note**: Ted Jenkin is the President of Exit Wealth and Exit Stage Left Advisors, one of the top business brokers and financial advisors in the United States. He is the author of the 21-day business cleanse. He is an expert on personal finance, the economy, taxes, real estate, entrepreneurship and more. Ted has done more than 1,500 television appearances.',
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message: 'Who represents Brad Pitt',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      "### Brad Pitt's Rep  \n- **Name**: Matthew Hiltzik \n- **Cell**: [917-747-0827](tel:9177470827) \n- **Email**: mhiltzik@hstrategies.com\n\n ",
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message:
      'I need a contact - here is their linkedin profile: https://www.linkedin.com/in/jim-olsonpr/',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      '### Head of Brand and Communications, Avelo Airlines  \n- **Name**: Jim Olson \n- **Cell**: [+1 312-219-0647](tel:+13122190647) \n- **Email**: jolson@aveloair.com\n\n ',
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message:
      '### Welcome to TMX Search. \n\n Just ask for any contacts you need. See examples above of how to ask me.',
    role: 'REPLY'
  }
];

export const nonNewsroomExampleChat = [
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message: 'Need a contact for Sean Spicer ',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      '### Trump’s Former Press Secretary \n- **Name**: Sean Spicer \n- **Cell**: [703-623-6167](tel:7036236167) \n- **Email**: sean@seanspicer.com\n\n ',
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message: 'Need a financial expert on tariffs ',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      '### Ted Jenkin  \n- **Cell**: [770-349-9141](tel:7703499141) \n- **Email**: ted@exitwealth.com \n- **Note**: Ted Jenkin is the President of Exit Wealth and Exit Stage Left Advisors, one of the top business brokers and financial advisors in the United States. He is the author of the 21-day business cleanse. He is an expert on personal finance, the economy, taxes, real estate, entrepreneurship and more. Ted has done more than 1,500 television appearances.',
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message: 'Who represents Brad Pitt',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      "### Brad Pitt's Rep  \n- **Name**: Matthew Hiltzik \n- **Cell**: [917-747-0827](tel:9177470827) \n- **Email**: mhiltzik@hstrategies.com\n\n ",
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message:
      'I need a contact - here is their linkedin profile: https://www.linkedin.com/in/jim-olsonpr/',
    role: 'USER'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:52 GMT',
    message:
      '### Head of Brand and Communications, Avelo Airlines  \n- **Name**: Jim Olson \n- **Cell**: [+1 312-219-0647](tel:+13122190647) \n- **Email**: jolson@aveloair.com\n\n ',
    role: 'REPLY'
  },
  {
    log_time: 'Sun, 06 Apr 2025 05:58:44 GMT',
    message:
      '### Welcome to TMX Search. \n\n Just ask for any contacts you need. See examples above of how to ask me.',
    role: 'REPLY'
  }
];
